import { create } from 'zustand';

interface DebugLog {
  id: string;
  timestamp: Date;
  type: 'request' | 'response' | 'error';
  data: any;
}

interface DebugState {
  isVisible: boolean;
  logs: DebugLog[];
  addLog: (type: 'request' | 'response' | 'error', data: any) => void;
  clearLogs: () => void;
  setIsVisible: (visible: boolean) => void;
}

export const useDebugStore = create<DebugState>((set) => ({
  isVisible: false,
  logs: [],
  
  addLog: (type, data) => set((state) => {
    // Skip empty formatting logs
    if (data.type === 'formatting' && 
        ((data.originalContent === '-' || data.originalContent === '') || 
         (data.formattedContent === '' || data.cleanedContent === ''))) {
      return state;
    }
    
    // Check for duplicate logs (same type and content within last 2 seconds)
    const now = new Date();
    const isDuplicate = state.logs.some(log => {
      const timeDiff = now.getTime() - log.timestamp.getTime();
      if (timeDiff > 2000) return false; // Only check recent logs (within 2 seconds)
      
      if (log.type === type && 
          JSON.stringify(log.data) === JSON.stringify(data)) {
        return true;
      }
      return false;
    });
    
    if (isDuplicate) return state;
    
    return {
      logs: [
        {
          id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          timestamp: new Date(),
          type,
          data
        },
        ...state.logs
      ].slice(0, 100) // Keep only the last 100 logs
    };
  }),
  
  clearLogs: () => set({ logs: [] }),
  
  setIsVisible: (visible) => set({ isVisible: visible })
}));